import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { FaFileSignature, FaShieldAlt, FaCrown } from "react-icons/fa";
import wintoCoin from "../../assets/images/winto-coin.png";
import "./InvestmentTiers.css";

const InvestmentTiers = () => {
  const { translations: tRaw } = useLanguage();
  const t = {
    ...tRaw,
    investment: { ...tRaw?.investment },
  };

  const tiers = [
    {
      amount:"USD 200,000,000",
      equity:"25%",
      return:"75%",
      winicoins: "16,666,667",
      color:"#374151"
    },
    
    {
      amount:"USD 100,000,000",
      equity:"20%",
      return:"60%",
      winicoins: "8,333,333",
      color:"#10b981"
    },
    // {
    //   amount:"USD 75,000,000",
    //   equity:"25%",
    //   return:"70%",
    //   winicoins: "6,250,000",
    //   color:"#374151"
    // },
    {
      amount:"USD 50,000,000",
      equity:"15%",
      return:"45%",
      winicoins: "4,166,667",
      color:"#ef4444"
    },
    {
      amount: "USD 25,000,000",
      equity: "8%",
      return: "24%",
      winicoins: "2,083,333",
      color: "#2563eb"
    },
    // { 
    //   amount: "USD 10,000,000", 
    //   equity: "3%", 
    //   return: "9%",
    //   winicoins: "833,333",
    //   color: "#6366f1"
    // },
    // { 
    //   amount: "USD 5,000,000", 
    //   equity: "3%", 
    //   return: "9%",
    //   winicoins: "416,667",
    //   color: "#8b5cf6"
    // },
    // { 
    //   amount: "USD 2,500,000", 
    //   equity: "1.5%", 
    //   return: "4.5%",
    //   winicoins: "208,333",
    //   color: "#10b981"
    // },
    // { 
    //   amount: "USD 1,000,000", 
    //   equity: "0.6%", 
    //   return: "3%",
    //   winicoins: "83,333",
    //   color: "#f59e0b"
    // },
    // { 
    //   amount: "USD 500,000", 
    //   equity: "0.3%", 
    //   return: "1.5%",
    //   winicoins: "41,667",
    //   color: "#ec4899"
    // },
  ];

  const benefits = [
    {
      icon: <FaFileSignature />,
      title: t.investment?.benefits?.contractsTitle || "Contracts Ready for Signing",
      description: t.investment?.benefits?.contractsDesc || "All legal documents prepared for immediate execution"
    },
    {
      icon: <FaShieldAlt />,
      title: t.investment?.benefits?.legalTitle || "Legal Protection Guaranteed",
      description: t.investment?.benefits?.legalDesc || "Full legal compliance and investor protection"
    },
    {
      icon: <FaCrown />,
      title: t.investment?.benefits?.limitedTitle || "Limited Investment Seats",
      description: t.investment?.benefits?.limitedDesc || "Exclusive opportunity with limited availability"
    }
  ];

  return (
    <section className="investment-tiers-section">
      <div className="tiers-container">
        <motion.h2
          className="tiers-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {t.investment?.tiersTitle || "Investment Tiers"}
        </motion.h2>
        
        <p className="tiers-subtitle">
          {t.investment?.tiersSubtitle || "Choose the investment level that matches your goals"}
        </p>

        {/* Investment Tiers Table */}
        <div className="tiers-table">
          <div className="table-header">
            <span>{t.investment?.amount || "Amount"}</span>
            <span>{t.investment?.equity || "Equity (partner)"}</span>
            <span>{t.investment?.fixedReturn || "Investor (Without Equity)"}</span>
            <span className="winicoins-header">
              <img src={wintoCoin} alt="WiniCoin" className="winicoins-icon" />
              {t.investment?.winicoins || "WiniCoins"}
            </span>
          </div>
          {tiers.map((tier, idx) => (
            <motion.div
              key={idx}
              className="table-row"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
            >
              <span>{tier.amount}</span>
              <span>{tier.equity}</span>
              <span>{tier.return}</span>
              <span className="invest-winicoins-value">{tier.winicoins}</span>
            </motion.div>
          ))}
        </div>

        {/* WiniCoins Explanation Section */}
        <motion.div 
          className="winicoins-explanation"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="winicoins-explanation-content">
            <div className="winicoins-explanation-icon">
              <img src={wintoCoin} alt="WiniCoin" className="explanation-coin-icon" />
            </div>
            <div className="winicoins-explanation-text">
              <h3 className="winicoins-explanation-title">
                {t.investment?.winicoinsExplanation?.title || "WiniCoins Guarantee"}
              </h3>
              <p className="winicoins-explanation-description">
                {t.investment?.winicoinsExplanation?.description || "Normal investors who invest in iWinto will receive the corresponding amount of WiniCoins in their wallet as a guarantee for their investment. WiniCoins will take some time to appear in your wallet after your investment is confirmed."}
              </p>
            </div>
          </div>
        </motion.div>

        {/* Investment Benefits Section */}
        <div className="investment-benefits">
          <motion.div 
            className="benefits-intro"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <h3>{t.investment?.benefits?.introText || "The partnership achieves financial revenue that corresponds to the profit percentage allocated from the total net profits for each year of the application's operation according to its general financial results."}</h3>
          </motion.div>
          
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <motion.div 
                key={index}
                className="benefit-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 + 0.3 }}
              >
                <div className="benefit-icon">
                  {benefit.icon}
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentTiers;